module.exports = __webpack_public_path__ + "static/img/frankapp.8d8ef9e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/frank/frankapp.png
// module id = 580
// module chunks = 1